import { GraduationCap } from 'lucide-react';
import { textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/** Lista de 30/10 (item 10): cursos do Treinamento (título e descrição). A página Cursos lê `?busca=`. */
interface CursoBusca {
  id: string;
  titulo: string;
}

const lista = (busca: string) => `${caminhoDaAba('treinamento', 'cursos')}?busca=${encodeURIComponent(busca)}`;

export const buscaTreinamento: FonteBuscaGlobal[] = [
  {
    chave: 'cursos',
    permissao: 'treinamento.ver',
    pagina: 'treinamento.cursos',
    grupo: 'buscaGlobal.cursos',
    posicao: 100,
    icone: GraduationCap,
    item: (c: CursoBusca) => ({ id: c.id, rotulo: textoLivre(c.titulo), link: lista(c.titulo) }),
    verTodos: lista,
  },
];
